<ng-container *ngIf="dataSource.data">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <li class="example-tree-container child-node-container">
          <div class="mat-tree-node">
            <button type="button" mat-icon-button disabled></button>
            <div class="mr-3">{{ node.name }}</div>
            <mat-checkbox [checked]="checklistSelection.isSelected(node)" (change)="todoLeafItemSelectionToggle(node)">
            </mat-checkbox>
          </div>
        </li>
      </mat-tree-node>
  
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <li class="example-tree-container root-node-container">
          <div class="mat-tree-node">
            <button type="button" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'remove' : 'add' }}
              </mat-icon>
            </button>
            <div class="mr-3 expand-node">{{ node.name }}</div>
            <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
              (change)="todoItemSelectionToggle(node)" class="" [color]="'primary'"></mat-checkbox>
          </div>
        </li>
      </mat-tree-node>
    </mat-tree>
  </ng-container>
  <!-- <label class="nr-sub-header-label">Select an appropriate region for the user</label> -->
  <!-- <div class="error" *ngIf="!checklistSelection.selected.length">
    Please Check at least one organizational Area
  </div> -->
  